import { render, staticRenderFns } from "./email-management.vue?vue&type=template&id=36adaf79"
import script from "./email-management.vue?vue&type=script&lang=js"
export * from "./email-management.vue?vue&type=script&lang=js"
import style0 from "./email-management.vue?vue&type=style&index=0&id=36adaf79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports